import React from 'react';

function StyleBuilder({ styleConfig, setStyleConfig }) {

  const handleColorChange = (key, value) => {
    setStyleConfig(prev => ({ ...prev, [key]: value }));
  };

  const handleNestedChange = (section, key, value) => {
    setStyleConfig(prev => ({
      ...prev,
      [section]: { ...prev[section], [key]: value }
    }));
  };

  return (
    <div className="mb-4">
      <h5 className="mb-3">Style Builder</h5>
      <div className="card">
        <div className="card-body">
          <h6 className="card-title mb-3">Global Colors</h6>
          <div className="mb-3">
            <label className="form-label">Primary Color</label>
            <input 
              type="color" 
              className="form-control form-control-color" 
              value={styleConfig.primary}
              onChange={e => handleColorChange('primary', e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Secondary Color</label>
            <input 
              type="color" 
              className="form-control form-control-color" 
              value={styleConfig.secondary}
              onChange={e => handleColorChange('secondary', e.target.value)}
            />
          </div>
        <hr className="my-3" />
        
        <h6 className="card-title mb-3">Top Bar Styles</h6>
        <div className="mb-3">
          <label className="form-label">Background Color</label>
          <input 
            type="color" 
            className="form-control form-control-color" 
            value={styleConfig.topBar.bgColor}
            onChange={e => handleNestedChange('topBar', 'bgColor', e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Text Color</label>
          <input 
            type="color" 
            className="form-control form-control-color" 
            value={styleConfig.topBar.textColor}
            onChange={e => handleNestedChange('topBar', 'textColor', e.target.value)}
          />
        </div>

        <hr className="my-3" />
          
          <h6 className="card-title mb-3">Header Styles</h6>
          <div className="mb-3">
            <label className="form-label">Background Color</label>
            <input 
              type="color" 
              className="form-control form-control-color" 
              value={styleConfig.header.bgColor}
              onChange={e => handleNestedChange('header', 'bgColor', e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Text Color</label>
            <input 
              type="color" 
              className="form-control form-control-color" 
              value={styleConfig.header.textColor}
              onChange={e => handleNestedChange('header', 'textColor', e.target.value)}
            />
          </div>
          <hr className="my-3" />
<h6 className="card-title mb-3">Hero Styles</h6>
<div className="mb-3">
  <label className="form-label">Subtitle Text Color</label>
  <input 
    type="color" 
    className="form-control form-control-color" 
    value={styleConfig.hero.subtitleColor}
    onChange={e => handleNestedChange('hero', 'subtitleColor', e.target.value)}
  />
</div>
<hr className="my-3" />
          
          {/* --- ADD THIS NEW SECTION --- */}
          <h6 className="card-title mb-3">Footer Styles</h6>
          <div className="mb-3">
            <label className="form-label">Background Color</label>
            <input 
              type="color" 
              className="form-control form-control-color" 
              value={styleConfig.footer.bgColor}
              onChange={e => handleNestedChange('footer', 'bgColor', e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Text Color</label>
            <input 
              type="color" 
              className="form-control form-control-color" 
              value={styleConfig.footer.textColor}
              onChange={e => handleNestedChange('footer', 'textColor', e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Link Color</label>
            <input 
              type="color" 
              className="form-control form-control-color" 
              value={styleConfig.footer.linkColor}
              onChange={e => handleNestedChange('footer', 'linkColor', e.target.value)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default StyleBuilder;